import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const h=t("argentina",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="white" />
            <path
                d="M0 4.5H24V9.83333H0V4.5ZM0 15.1667H24V20.5H0V15.1667Z"
                fill="#338AF3" />
            <path
                d="M12.0234 14.3716C13.059 14.3716 13.8984 13.5338 13.8984 12.5003C13.8984 11.4667 13.059 10.6289 12.0234 10.6289C10.9879 10.6289 10.1484 11.4667 10.1484 12.5003C10.1484 13.5338 10.9879 14.3716 12.0234 14.3716Z"
                fill="#FFDA44" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.0234 10.7456C11.0526 10.7456 10.2656 11.5311 10.2656 12.5C10.2656 13.4689 11.0526 14.2544 12.0234 14.2544C12.9943 14.2544 13.7812 13.4689 13.7812 12.5C13.7812 11.5311 12.9943 10.7456 12.0234 10.7456ZM10.0312 12.5C10.0312 11.4019 10.9232 10.5117 12.0234 10.5117C13.1237 10.5117 14.0156 11.4019 14.0156 12.5C14.0156 13.5981 13.1237 14.4883 12.0234 14.4883C10.9232 14.4883 10.0312 13.5981 10.0312 12.5Z"
                fill="#D6AB00" />
        </svg>
    `),l=i`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_4915_40011"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25">
            <circle
                cx="12"
                cy="12.5"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4915_40011)">
            <g clip-path="url(#clip0_4915_40011)">
                <path
                    d="M-5.96484 0.5H29.965V24.5H-5.96484V0.5Z"
                    fill="white" />
                <path
                    d="M-5.96484 0.5H29.965V8.5H-5.96484V0.5ZM-5.96484 16.5H29.965V24.5H-5.96484V16.5Z"
                    fill="#338AF3" />
                <path
                    d="M12.035 15.3074C13.5853 15.3074 14.8421 14.0507 14.8421 12.5004C14.8421 10.9501 13.5853 9.69336 12.035 9.69336C10.4848 9.69336 9.22803 10.9501 9.22803 12.5004C9.22803 14.0507 10.4848 15.3074 12.035 15.3074Z"
                    fill="#FFDA44" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.0352 9.86846C10.5818 9.86846 9.40361 11.0467 9.40361 12.5C9.40361 13.9534 10.5818 15.1316 12.0352 15.1316C13.4886 15.1316 14.6668 13.9534 14.6668 12.5C14.6668 11.0467 13.4886 9.86846 12.0352 9.86846ZM9.05273 12.5C9.05273 10.8529 10.388 9.51758 12.0352 9.51758C13.6824 9.51758 15.0176 10.8529 15.0176 12.5C15.0176 14.1472 13.6824 15.4825 12.0352 15.4825C10.388 15.4825 9.05273 14.1472 9.05273 12.5Z"
                    fill="#D6AB00" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4915_40011">
                <rect
                    width="36"
                    height="24"
                    fill="white"
                    transform="translate(-5.96484 0.5)" />
            </clipPath>
        </defs>
    </svg>
`,s=t("argentina_rounded",l),r=t("ARS",l);export{r as ARS,h as Argentina,s as ArgentinaRounded};
